import { render, staticRenderFns } from "./ClassEditPanel.vue?vue&type=template&id=294d3889&"
import script from "./ClassEditPanel.vue?vue&type=script&lang=js&"
export * from "./ClassEditPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports